// -- AJAX --------------------------------------------------------------------
export const AJAX_CALL_STARTED = 'AJAX_CALL_STARTED';
export const AJAX_CALL_ENDED = 'AJAX_CALL_ENDED';
export const AJAX_CALL_FAILED = 'AJAX_CALL_FAILED';

// -- ADRESSEN ----------------------------------------------------------------

export const GEMEENTEN_LOADED = 'GEMEENTEN_LOADED';

// -- REFERENCES --------------------------------------------------------------
export const REFERENCES_LOADED = 'REFERENCES_LOADED';


export const ACTIVE_ACTIVETOPNAVITEMID_UPDATED = 'ACTIVE_ACTIVETOPNAVITEMID_UPDATED';
export const LAYOUT_UPDATED = 'LAYOUT_UPDATED';

export const ADD_ERROR = 'ADD_ERROR';
export const CLEAR_ERRORS = 'CLEAR_ERRORS';

export const THROW_EXCEPTION = 'THROW_EXCEPTION';
export const CLEAR_EXCEPTION = 'CLEAR_EXCEPTION';

export const READ_SETTINGS_SUCCESS = 'READ_SETTINGS_SUCCESS';
export const ACCOUNT_SET = 'ACCOUNT_SET';
export const DISABLE_PAGE = 'DISABLE_PAGE';

export const VALIDATIESTATUS_LOADED = 'VALIDATIESTATUS_LOADED';
//export const SIDENAV_LOADED = 'SIDENAV_LOADED';
